<template>
  <div>
    <div style="height:70px">&nbsp;</div>
    <van-tabbar z-index="3" v-model="activeBar">
      <van-tabbar-item name="home" icon="wap-home-o" to="/home">
        首页
      </van-tabbar-item>
      <van-tabbar-item name="cart" icon="cart-o" to="/cart">
        购物车
      </van-tabbar-item>
      <van-tabbar-item name="order" icon="gem-o" to="/order">
        订单
      </van-tabbar-item>
      <van-tabbar-item name="my" icon="user-o" to="/my">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  name: 'foot',
  data () {
    return {
      activeBar: this.active
    }
  },
  props: {
    active: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/foot/index.vue